import React from 'react';

export default class ConfirmableButton extends React.Component {
  static defaultProps = {
    buttonText: 'Click Here',
    confirmationText: 'Are you sure?',
    affirmativeText: 'Yes',
    declineText: 'No',
    confirmationAction: () => console.log("No action set for ConfirmableButton confirmation")
  }
  
  constructor(props) {
    super(props);
    this.state = { isConfirming: false }
    this.showConfirmationButtons = this.showConfirmationButtons.bind(this);
    this.hideConfirmationButtons = this.hideConfirmationButtons.bind(this);
    this.confirm = this.confirm.bind(this);
  }

  showConfirmationButtons() {
    this.setState( { isConfirming: true} );
  }

  hideConfirmationButtons() {
    this.setState( { isConfirming: false} );
  }

  confirm() {
    this.props.confirmationAction();
    this.hideConfirmationButtons();
  }

  render() {
    let confirmation = '';
    let primaryButton = '';
    let secondaryButton = '';

    if (this.state.isConfirming) {
      confirmation = this.props.confirmationText;
      
      primaryButton = <button onClick={this.confirm}>
        {this.props.affirmativeText}
      </button>
      
      secondaryButton = <button onClick={this.hideConfirmationButtons}>
        {this.props.declineText}
      </button>
    }
    else {
      primaryButton = <button onClick={this.showConfirmationButtons}>
        {this.props.buttonText}
      </button>
    }

    return (
      <div>
        {primaryButton}
        {secondaryButton}
        {confirmation}
      </div>
    );
  }
}
